<template>
  <div class="my-5" :class="col ? `col-lg-${col}` : ''">
    <!-- :class="{ disabled_input: disabled }" -->
    <div
      :class="{
        errors: errors && !focused,
      }"
      class="input_wrapper top_label select_wrapper"
    >
      <label class="form-label" v-if="placeholder">
        <img v-if="icon" :src="icon" class="img" />
        {{ placeholder }}
        <span class="text-danger" v-if="required">*</span>
      </label>
      <multiselect
        :options="optionsList"
        :label="label"
        :track-by="trackBy"
        :placeholder="$t('PLACEHOLDERS.required_message', {})"
        :searchable="true"
        :allow-empty="true"
        :show-labels="false"
        :open-direction="'bottom'"
        :value="value"
        @input="
          updateValue($event);
          $emit('fireInputEvent');
        "
        :multiple="multiple"
        :readonly="readonly"
        :disabled="disabled"
        :close-on-select="focus"
        v-bind="$attrs"
        v-on="$listeners"
        @open="onfocus"
        @close="onBlur"
      >
      </multiselect>
    </div>
    <p v-if="errors && !focused" class="error-msg">{{ errors }}</p>
  </div>
</template>
<script>
export default {
  inheritAttrs: false,
  name: "BaseSelectInput",
  emits: ["fireInputEvent"],
  data() {
    return {
      focused: false,
    };
  },
  props: {
    icon: {
      required: false,
      type: String,
    },
    errors: {
      requireed: false,
      type: String,
    },
    col: {
      required: false,
      type: String | Number,
    },
    placeholder: {
      required: false,
      type: String,
    },
    optionsList: {
      required: true,
    },
    label: {
      type: String,
      default: "name",
    },
    value: {
      required: true,
    },
    placeholder: {
      required: false,
      type: String,
    },
    multiple: {
      required: false,
      type: Boolean,
      default: false,
    },
    trackBy: {
      required: false,
      type: String,
      default: "id",
    },
    required: {
      required: false,
      type: Boolean,
      default: false,
    },
    readonly: {
      required: false,
      type: Boolean,
      default: false,
    },
    focus: {
      required: false,
      type: Boolean,
      default: true,
    },
    disabled: {
      required: false,
      type: Boolean,
      default: false,
    },

    // ====== End:: General Inputs Props ====== //
  },
  methods: {
    updateValue(e) {
      console.log("change", e);

      this.$emit("input", e);
    },

    onBlur(event) {
      this.focused = false;

      this.$emit("blur", event);
    },
    onfocus(event) {
      console.log("opened");
      this.focused = true;

      this.$emit("blur", event);
    },
  },
};
</script>

<style>
form .input_wrapper.top_label.select_wrapper .multiselect .multiselect__select {
  display: block !important;
  margin-top: 11px !important;
  height: 44px !important;
}
form
  .input_wrapper.top_label.select_wrapper
  .multiselect--active
  .multiselect__select {
  margin-bottom: 50px !important ;
  transform: translateY(0px) !important;
}
form
  .input_wrapper.top_label.select_wrapper
  .multiselect
  .multiselect__select::before {
  top: 50% !important;
  transform: translateY(-50%) !important;
  border-width: 7px 7px 0px;
}
form
  .input_wrapper.top_label.select_wrapper
  .multiselect--active
  .multiselect__select::before {
  border-width: 7px 7px 0px;
}

.input_wrapper.errors {
  border-color: #f44336 !important;
  background-color: transparent !important;
  color: #f44336 !important;
}
.input_wrapper.errors label,
.input_wrapper.errors span {
  color: #f44336 !important;
}
.input_wrapper.errors input::placeholder {
  color: #f44336;
}
.img {
  width: 25px;
  border-radius: 50%;
  height: 25px;
  display: inline-block;
  object-fit: cover;
}
.multiselect--disabled::before,
.multiselect__select::before,
.multiselect--disabled,
.multiselect__select {
  background-color: transparent !important;
}
</style>
